const isVisible = (element, padding = 0) => {
    if (!element) return false;
    const boundingClientRect = element.getBoundingClientRect();
    const viewHeight = Math.max(document?.documentElement?.clientHeight, window?.innerHeight);
    const offScreenAboveView = boundingClientRect.bottom + padding < 0;
    const offScreenBelowView = boundingClientRect.top - viewHeight - padding >= 0;

    return !offScreenAboveView && !offScreenBelowView;
};

export default isVisible;
